export const AutomationModalPaneOptions = {
  CREATE: 'create',
  EDIT: 'edit',
  LIST: 'list',
} as const;

export const AutomationModalActionType = {
  UPDATE_STATUS: 'update_status',
  SEND_REFERENCE_CHECK: 'send_reference_check',
} as const;

export enum EmailTemplateVariable {
  CANDIDATE_FIRST_NAME = '{Candidate first name}',
  CANDIDATE_LAST_NAME = '{Candidate last name}',
  CANDIDATE_PHONE = '{Candidate phone}',
  JOB_TITLE = '{Job title}',
  SENDER_FIRST_NAME = '{Sender first name}',
  SENDER_LAST_NAME = '{Sender last name}',
  SCHOOL_NAME = '{School name}',
  DISTRICT_NAME = '{District name}',
  INTERVIEW_DATE_TIME = '{Interview date & time}',
  REFERENCE_SALUTATION = '{Reference salutation}',
  REFERENCE_FIRST_NAME = '{Reference first name}',
  REFERENCE_LAST_NAME = '{Reference last name}',
  REFERENCE_EMAIL = '{Reference email}',
  REFERENCE_PHONE = '{Reference phone}',
}

export const AutomationTrigger = {
  QUESTION_ANSWER: 'question_answer',
  UPDATE_STATUS: 'update_status',
} as const;

export const AutomationListVariant = {
  READ_ONLY: 'read_only',
  EDITABLE: 'editable',
} as const;

export const AutomationType = {
  QUESTION_ANSWER_UPDATE_STATUS: 'question_answer_update_status',
  STATUS_UPDATE_REFERENCE_CHECK: 'status_update_reference_check',
} as const;
